import React from 'react';
import Button from 'react-toolbox/lib/button';

const ActionButton = ({ backgroundColor, label, color, href, style }) => {
  return (
    <a href={href}>
      <Button
        raised
        label={label}
        style={{ backgroundColor, color, ...style }}
      />
    </a>
  );
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/ActionButton.js